/*
 *  -----------------------------------------------------------------------
 *    <copyright file="home/ra-summary.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'hooks';
import { HC_COLORS_MUTED, OpraColours, OpraStackingOptions } from 'interfaces/opra-chart.interface';
import { getIsActiveField } from 'utils/convertor';
import ColumnChart from 'views/components/core/charts/column-chart';
import PanelFrame from 'views/components/core/panel-frame';

const HomeRiskAssessmentSummary = ({ summaries, userStudies }: any) => {
    const { t } = useTranslation();
    const [studies, setStudies] = useState([]);

    useEffect(() => {
        if (summaries && userStudies) {
            const array = summaries.filter((item: any) => {
                const module = userStudies.find((el: any) => el.id === item.studyId)?.modules;
                return getIsActiveField('RAM', module);
            });
            setStudies(array);
        }
    }, [summaries, userStudies]);

    const formatTooltip = (self: any) => {
        const percentage = Math.round(self.percentage);
        return `Study ${self.x} <br/> Total Risk(s): ${self.total} <br/> # ${self.series.name}: ${self.y} <br/>
            % ${self.series.name}: ${percentage}`;
    };

    return (
        <PanelFrame title={t('home-riskAssessmentSummary')} headerColor="#fff" toggleLegend={false}>
            {(getRef: any) => (
                <ColumnChart
                    getRef={getRef}
                    plotTitle={t('home-riskAssessmentSummary')}
                    hidePlotTitle
                    formatTooltip={formatTooltip}
                    categories={studies.map((summary: any) => summary.studyNum)}
                    yAxisTitle={t('home-riskScoreRatingPercentage')}
                    xAxisTitle={t('home-studyNumbers')}
                    stacking={OpraStackingOptions.percentages}
                    series={[
                        {
                            name: t('Red'),
                            color: HC_COLORS_MUTED[OpraColours.Red],
                            values: studies.map((summary: any) => summary.numRedRisks),
                            onClick: () => {},
                        },
                        {
                            name: t('Amber'),
                            color: HC_COLORS_MUTED[OpraColours.Amber],
                            values: studies.map((summary: any) => summary.numAmberRisks),
                            onClick: () => {},
                        },
                        {
                            name: t('Green'),
                            color: HC_COLORS_MUTED[OpraColours.Green],
                            values: studies.map((summary: any) => summary.numGreenRisks),
                            onClick: () => {},
                        },
                        {
                            name: t('notEvaluated'),
                            color: HC_COLORS_MUTED[OpraColours.DarkGrey],
                            values: studies.map((summary: any) => summary.numUnevaluatedRisks),
                            onClick: () => {},
                        },
                    ]}
                />
            )}
        </PanelFrame>
    );
};

export default React.memo(HomeRiskAssessmentSummary);
